import { UseInfiniteQueryResult } from 'react-query';
import { getApiLocale } from 'modules/i18n';
import { useInfiniteQueryBase } from '../../hooks';
import { fetchHardSkillsPage } from './api';
import { USE_HARD_SKILLS_QUERY_KEY } from './constants';
import { HardSkillsResponse } from './types';

export const useHardSkillsInfiniteQuery =
  (): UseInfiniteQueryResult<HardSkillsResponse> => {
    return useInfiniteQueryBase(
      [USE_HARD_SKILLS_QUERY_KEY],
      pageParam => {
        const locale = getApiLocale();
        return fetchHardSkillsPage(
          pageParam,
          locale
        ) as Promise<HardSkillsResponse | null>;
      },
      {
        entityName: 'hardSkills'
      }
    );
  };
